// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExploreConversations-cls1___3d56a98039743b5e632{/*!*/}.ExploreConversations-cls2___66e75fe7d5b01f96f0c{height:auto;width:auto;margin:-8px 0 -8px auto;padding:6px 20px;font-size:14px;text-align:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "ExploreConversations-cls1___3d56a98039743b5e632",
	"cls2": "ExploreConversations-cls2___66e75fe7d5b01f96f0c ExploreConversations-cls1___3d56a98039743b5e632"
};
export default ___CSS_LOADER_EXPORT___;
